import React from 'react';
import ComponentSectionsFeaturedProjects from '../sections/ComponentSectionsFeaturedProjects';
import ComponentSectionsProcess from '../sections/ComponentSectionsProcess';
import ComponentSectionsFeaturedNews from '../sections/ComponentSectionsFeaturedNews';
import ComponentSectionsFullWidthMedia from '../sections/ComponentSectionsFullWidthMedia';
import ComponentSectionsHomeHero from '../sections/ComponentSectionsHomeHero';
import ComponentSectionsLogoWidthDescription from '../sections/ComponentSectionsLogoWidthDescription';
import ComponentSections2ColumnMedia from '../sections/ComponentSections2ColumnMedia';
import ComponentSections2ColumnTextBlock from '../sections/ComponentSections2ColumnTextBlock';
import ComponentSectionsAanerdiaBox from '../sections/ComponentSectionsAanerdiaBox';
import ComponentSectionsOurTeam from '../sections/ComponentSectionsOurTeam';
import ComponentSectionsInlineTextBlock from '../sections/ComponentSectionsInlineTextBlock';
import ComponentSections2ColumnMediaWithContent from '../sections/ComponentSections2ColumnMediaWithContent';
import ComponentSectionsAwardsAndRecognition from '../sections/ComponentSectionsAwardsAndRecognition';
import ComponentSectionsExploreOurProjects from '../sections/ComponentSectionsExploreOurProjects';
import ComponentSectionsFaQs from '../sections/ComponentSectionsFaQs';
import ComponentSectionsContactTabs from '../sections/ComponentSectionsContactTabs';
import ComponentSectionsResources from '../sections/ComponentSectionsResources';
import ComponentSectionsOurServices from '../sections/ComponentSectionsOurServices';

export default function renderBlock(block: any) {
  switch (block.__typename) {
    case 'ComponentSectionsHomeHero':
      return <ComponentSectionsHomeHero data={block} />;
    case 'ComponentSectionsFeaturedProjects':
      return <ComponentSectionsFeaturedProjects data={block} />;
    case 'ComponentSectionsProcess':
      return <ComponentSectionsProcess data={block} />;
    case 'ComponentSectionsFeaturedNews':
      return <ComponentSectionsFeaturedNews data={block} />;
    case 'ComponentSectionsFullWidthMedia':
      return <ComponentSectionsFullWidthMedia data={block} />;
    case 'ComponentSectionsLogoWidthDescription':
      return <ComponentSectionsLogoWidthDescription data={block} />;
    case 'ComponentSections2ColumnMedia':
      return <ComponentSections2ColumnMedia data={block} />;
    case 'ComponentSections2ColumnTextBlock':
      return <ComponentSections2ColumnTextBlock data={block} />;
    case 'ComponentSectionsAanerdiaBox':
      return <ComponentSectionsAanerdiaBox data={block} />;
    case 'ComponentSectionsOurTeam':
      return <ComponentSectionsOurTeam data={block} />;
    case 'ComponentSectionsInlineTextBlock':
      return <ComponentSectionsInlineTextBlock data={block} />;
    case 'ComponentSections2ColumnMediaWithContent':
      return <ComponentSections2ColumnMediaWithContent data={block} />;
    case 'ComponentSectionsAwardsAndRecognition':
      return <ComponentSectionsAwardsAndRecognition data={block} />;
    case 'ComponentSectionsExploreOurProjects':
      return <ComponentSectionsExploreOurProjects data={block} />;
    case 'ComponentSectionsFaQs':
      return <ComponentSectionsFaQs data={block} />;
    case 'ComponentSectionsContactTabs':
      return <ComponentSectionsContactTabs data={block} />;
    case 'ComponentSectionsResources':
      return <ComponentSectionsResources data={block} />;
    case 'ComponentSectionsOurServices':
      return <ComponentSectionsOurServices data={block} />;
    default:
      return null; // Or a fallback component
  }
};